export default class Emial {
  static saveDraft (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/saveDraft', 'post', data, axiosOption, httpOption);
  }
  static sendEmail (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/send', 'post', data, axiosOption, httpOption);
  }
  static getEmailList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/list', 'post', data, axiosOption, httpOption);
  }

  static putWaste (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/waste', 'post', data, axiosOption, httpOption);
  }
  static deleteWaste (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/delete', 'post', data, axiosOption, httpOption);
  }
  
  static getCount (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/emailNum', 'get', data, axiosOption, httpOption);
  }
  static read(sender, data, axiosOption, httpOption) {
  return sender.doUrl('/admin/upms/oaEmail/read', 'post', data, axiosOption, httpOption);
  }
  static recentContacts (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/recentContacts', 'post', data, axiosOption, httpOption);
  } 
  static restore (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmail/restore', 'post', data, axiosOption, httpOption);
  }
  // 获取附件id 
  static getFileId (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaEmailFile/add', 'post', data, axiosOption, httpOption);
  }
} 
